import { render, staticRenderFns } from "./clerk.vue?vue&type=template&id=72b9c766&scoped=true"
import script from "./clerk.vue?vue&type=script&lang=js"
export * from "./clerk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b9c766",
  null
  
)

export default component.exports